import { IWellnessPlanCancelAutoRenewalResp } from "../wellness-plan.interface";
import { WELLNESS_PLAN_CANCEL_RENEWAL } from "./wellness-plan-cancel-renewal.mutation";
import { useMutation } from "@apollo/client";

export const useCancelWellnessPlanAutoRenewal = () => {
  const [cancelWellnessPlanAutoRenewal, { data, loading, error }] =
    useMutation<IWellnessPlanCancelAutoRenewalResp>(WELLNESS_PLAN_CANCEL_RENEWAL);

  const cancelRenewalWellnessPlan = (petId: string) => {
    cancelWellnessPlanAutoRenewal({
      variables: {
        petId,
      },
    });
  };

  return {
    cancelRenewalWellnessPlan,
    response: data?.cancelWellnessPlanAutoRenewal,
    loading,
    error,
  };
};
